/**
 * ClientLogo Molecule Component
 * Single client logo with company name for accessibility
 */

import React from 'react';
import { storyblokEditable } from '@/lib/blocks';
import { Image } from '@/components/atoms/Image';
import type { ClientLogoBlok } from '@/types';

export interface ClientLogoProps {
  blok: ClientLogoBlok;
  className?: string;
}

export const ClientLogo: React.FC<ClientLogoProps> = ({ blok, className = '' }) => {
  const { logo_image, company_name } = blok;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`flex items-center justify-center ${className}`}
    >
      {logo_image?.filename && (
        <Image
          src={logo_image.filename}
          alt={company_name || logo_image.alt || 'Client logo'}
          className="h-8 md:h-10 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity"
        />
      )}
    </div>
  );
};

export default ClientLogo;
